import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

const functionButtons = ytVueGlobalStore.instantGet('functional-buttons');
export default {
  namespaced: true,
  state: {
    ...functionButtons,
  },
};
